<template>
  <div>
    <div v-if="!loading">
      <NumberFormGroup
          :value="value.offset"
          name="offset"
          label="Offset"
          :error="(errors.offset || [])[0]"
          help-text="The number of items to skip, before getting the items to display."
          @input="emit('offset', $event)"
      />

      <RadioFormGroup
          :value="value.context"
          name="context"
          label="Context"
          :error="(errors.context || [])[0]"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
          @input="emit('context', $event)"
      />

      <SelectFormGroup
          :value="value.context_option"
          name="context_option"
          label="Context Option"
          :error="(errors.context_option || [])[0]"
          :options="[{value: 'content-article-references', label: 'Content Article References'}, {value: 'content-node-company', label: 'Content Node Company'}, {value: 'content-article-category', label: 'Content Article Category'}]"
          :nullable="true"
          @input="emit('context_option', $event)"
      />

      <SelectFormGroup
          :value="value.content_article_flag_id"
          name="content_article_flag_id"
          label="Content Article Flag"
          :error="(errors.content_article_flag_id || [])[0]"
          :options="contentArticleFlagOptions"
          :nullable="true"
          help-text="A flag to put on top when ordering articles in this block."
          @input="emit('content_article_flag_id', $event)"
      />

      <SelectFormGroup
          :value="value.content_article_label_id"
          name="content_article_label_id"
          label="Content Article Label"
          :error="(errors.content_article_label_id || [])[0]"
          :options="contentArticleLabelOptions"
          :nullable="true"
          @input="emit('content_article_label_id', $event)"
      />

      <TypeaheadFormGroup
          :value="value.content_article_id"
          name="content_article_id"
          label="Content Article"
          help-text="A specific article to show in the teaser. Overrides all other settings."
          :error="(errors.content_article_id || [])[0]"
          endpoint="/api/v2/content-articles"
          :params="{'filter[portal_id]': portal.id}"
          :token="shared.token"
          path="data.data"
          :result-label-property="contentArticle => contentArticle.attributes.title"
          :load-initial="true"
          @input="emit('content_article_id', $event)"
      />

      <SelectFormGroup
          :value="value.is_editorial"
          name="is_editorial"
          label="Partner Type"
          :error="(errors.is_editorial || [])[0]"
          :options="[{value: '1', label:'Editorial Partner'}, {value: '0', label:'Partner'}]"
          :nullable="true"
          placeholder="All"
          @input="emit('is_editorial', $event)"
      />

      <RadioFormGroup
          :value="value.hide_publish_at"
          name="hide_publish_at"
          label="Hide Publication Date"
          :error="(errors.hide_publish_at || [])[0]"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
          @input="emit('hide_publish_at', $event)"
      />

      <RadioFormGroup
          :value="value.hide_subheading"
          name="hide_subheading"
          label="Hide Subheading"
          :error="(errors.hide_subheading || [])[0]"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
          @input="emit('hide_subheading', $event)"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {NumberFormGroup, RadioFormGroup, SelectFormGroup, TypeaheadFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      contentArticleFlags: null,
      contentArticleLabels: null,

      shared: store,
      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    contentArticleFlagOptions() {
      return this.contentArticleFlags.map(contentArticleFlag => {
        return {
          value: contentArticleFlag.id,
          label: contentArticleFlag.attributes.name
        }
      })
    },

    contentArticleLabelOptions() {
      return this.contentArticleLabels.map(contentArticleLabel => {
        return {
          value: contentArticleLabel.id,
          label: contentArticleLabel.attributes.name
        }
      })
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },

    load() {
      Promise.all([
        http.get('/api/v2/content-article-flags', {'filter[portal_id]': this.portal.id}),
        http.get('/api/v2/content-article-labels', {'filter[portal_id]': this.portal.id})
      ]).then(responses => {
        this.contentArticleFlags = responses[0].data.data
        this.contentArticleLabels = responses[1].data.data

        this.loading = false
      })
    }
  }
}
</script>
